import api from '../config/api';

const API_ENDPOINTS = {
  COMPANIES: '/companies'
};

export const companyService = {
  // Get all companies (from hosted auth API)
  async getAllCompanies() {
    try {
      console.log('🔍 Fetching companies from hosted API:', API_ENDPOINTS.COMPANIES);
      const response = await api.authApi.get(API_ENDPOINTS.COMPANIES);
      console.log('📊 Companies API response:', response);
      
      // Handle different response structures
      let companiesData;
      if (response.data.data && Array.isArray(response.data.data)) {
        companiesData = response.data.data;
      } else if (Array.isArray(response.data)) {
        companiesData = response.data;
      } else {
        companiesData = [];
      }
      
      return { 
        success: true, 
        data: companiesData 
      };
    } catch (error) {
      console.error('Error fetching companies from hosted API:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch companies' 
      };
    }
  },

  // Get company by ID
  async getCompanyById(companyId) {
    try {
      const response = await api.get(`${API_ENDPOINTS.COMPANIES}/${companyId}`);
      return { 
        success: true, 
        data: response.data.data || response.data 
      };
    } catch (error) {
      console.error('Error fetching company:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch company' 
      };
    }
  },

  // Create company
  async createCompany(companyData) {
    try {
      console.log('🆕 Creating company:', companyData);
      const response = await api.post(API_ENDPOINTS.COMPANIES, companyData);
      console.log('✅ Company created:', response.data);
      
      return { 
        success: true, 
        data: response.data.data || response.data 
      };
    } catch (error) {
      console.error('Error creating company:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to create company' 
      };
    }
  },

  // Update company
  async updateCompany(companyId, companyData) {
    try {
      console.log('📝 Updating company:', companyId, companyData);
      const response = await api.put(`${API_ENDPOINTS.COMPANIES}/${companyId}`, companyData);
      console.log('✅ Company updated:', response.data);
      
      return { 
        success: true, 
        data: response.data.data || response.data 
      };
    } catch (error) {
      console.error('Error updating company:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to update company' 
      };
    }
  },

  // Delete company
  async deleteCompany(companyId) {
    try {
      console.log('🗑️ Deleting company:', companyId);
      const response = await api.delete(`${API_ENDPOINTS.COMPANIES}/${companyId}`);
      console.log('✅ Company deleted:', response.data);
      
      return { 
        success: true, 
        message: response.data.message || 'Company deleted successfully' 
      };
    } catch (error) {
      console.error('Error deleting company:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to delete company' 
      };
    }
  }
};

export default companyService;
